// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NE7B3","left":"styles_left__1T6CF"};